import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class TokenMethod extends React.Component {
    static propTypes = {
        token: PropTypes.object.isRequired,
        card_tokens: PropTypes.array.isRequired,
        payment_method: PropTypes.string,
        selected_card_token: PropTypes.object,
        is_password_required: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        onCloseModal: PropTypes.func.isRequired,
        confirmClickHandler: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.state = {
            password: '',
        };
        this.password_input = null;
    }

    getImageUrl = () => {
        const image_url = `${Mobi2Go.app.base_url}/store/application/v3/dist/img/card-logos/`;
        const card_type = this.props.token.card_type
            ? this.props.token.card_type.toLowerCase()
            : null;
        switch (card_type) {
            case 'visa':
                return `${image_url}visa.svg`;
            case 'mastercard':
                return `${image_url}mastercard.svg`;
            case 'amex':
                return `${image_url}amex.svg`;
            default:
                return `${image_url}card.svg`;
        }
    };

    isMethodActive = () => {
        return (
            this.props.payment_method === 'online' &&
            !!this.props.selected_card_token &&
            this.props.selected_card_token.id === this.props.token.id
        );
    };

    getPassword = () => {
        return this.state.password;
    };

    focusPassword = () => {
        if (this.password_input) {
            this.password_input.focus();
        }
    };

    onMethodClick = () => {
        if (this.isMethodActive()) {
            return;
        }
        this.props.onClick(this.props.token);
    };

    onMethodKeyDown = e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onMethodClick();
        }
    };

    onPasswordKeyDown = e => {
        if (e.keyCode === 13) {
            this.props.confirmClickHandler();
        }
    };

    onRemoveClick = () => {
        const { t } = this.props;
        Mobi2Go.UI.centeredAlert({
            title: t('remove_card_title'),
            body: t('remove_card_body'),
            primary_button: t('remove_card_primary_button'),
            secondary_button: t('remove_card_secondary_button'),
            onPrimaryButtonClick: () => {
                Mobi2Go.UI.centeredAlert({
                    title: t('remove_card_alert_title'),
                    body: t('remove_card_alert_body'),
                    temp: true,
                    temp_duration: 1200,
                    show_progress_bar: true,
                    primary_button: null,
                });

                Mobi2Go.Customer.removePaymentCardToken(
                    { id: this.props.token.id },
                    () => {
                        Mobi2Go.Order.load(Mobi2Go.UI.closeAlert);
                    }
                );
            },
        });
    };

    onResetPasswordClick = () => {
        const { t } = this.props;
        const email = Mobi2Go.Customer.getEmail();
        Mobi2Go.UI.centeredAlert({
            title: t('reset_password_title'),
            body: t('reset_password_body'),
            primary_button: t('reset_password_primary_button'),
            secondary_button: t('reset_password_secondary_button'),
            onPrimaryButtonClick: () => {
                Mobi2Go.Customer.sendPasswordReset(email);
                this.props.onCloseModal();
                Mobi2Go.UI.trigger('showCustomerPasswordRecovery', email);
                Mobi2Go.Order.log(
                    'password recovery started from payment method view'
                );
            },
        });
    };

    render() {
        const { t } = this.props;
        return (
            <div
                className="m2g-order-confirmation-payment-method m2g-order-confirmation-payment-card-token"
                data-method="online"
                data-token
                data-token-count={this.props.card_tokens.length}
                data-is-password-required={this.props.is_password_required}
                data-token-id={this.props.token.id}
                data-checked={this.isMethodActive()}
                onClick={this.onMethodClick}
            >
                <input
                    type="checkbox"
                    data-method="online"
                    className="m2g-order-confirmation-payment-method-checkbox m2g-order-confirmation-payment-card-token-checkbox"
                    data-token-id={this.props.token.id}
                    checked={this.isMethodActive()}
                    onChange={this.onMethodClick}
                    onKeyDown={this.onMethodKeyDown}
                />

                <img
                    className="m2g-order-confirmation-payment-card-token-icon-image"
                    src={this.getImageUrl()}
                />

                <div className="m2g-order-confirmation-payment-card-token-details">
                    <div className="m2g-order-confirmation-payment-card-token-name">
                        {this.props.token.card_name}
                    </div>
                    <div className="m2g-order-confirmation-payment-card-token-number m2g-text--offset">
                        {this.props.token.card_number}
                    </div>
                </div>

                <div
                    data-remove-token
                    data-token-id={this.props.token.id}
                    className="m2g-order-confirmation-payment-card-token-delete-button m2g-icon m2g-icon--cross"
                    onClick={this.onRemoveClick}
                />

                {this.props.is_password_required &&
                    (this.props.card_tokens.length === 1 ||
                        this.isMethodActive()) && (
                        <div className="m2g-order-confirmation-payment-card-token-password">
                            <div
                                className="m2g-order-confirmation-payment-card-token-password-input m2g-input-container"
                                data-icon-before
                            >
                                <span className="m2g-icon m2g-icon--padlock" />
                                <input
                                    className="m2g-input"
                                    placeholder={t('password_placeholder')}
                                    type="password"
                                    data-password-input
                                    value={this.state.password}
                                    onChange={e =>
                                        this.setState({
                                            password: e.target.value,
                                        })
                                    }
                                    onKeyDown={this.onPasswordKeyDown}
                                    ref={el => (this.password_input = el)}
                                />
                            </div>
                            <div
                                data-forgot-password
                                className="m2g-order-confirmation-payment-card-token-password-forgot-password m2g-text--link m2g-text--offset"
                                onClick={this.onResetPasswordClick}
                            >
                                {t('forgot_password')}
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(TokenMethod);
